const isPageLoading = state => state.isPageLoading
const isComponentLoading = state => state.isComponentLoading
const appError = state => state.appError
const appNotification = state => state.appNotification
const isCordova = () => process.env.VUE_APP_MODE === 'cordova'

export default {
  isPageLoading,
  isComponentLoading,
  appError,
  appNotification,
  isCordova,
}
